import React, { useEffect, useState, useRef } from "react";

import { useDocTitle, useForm } from "../../utils/hooks";
import Accordion from "../common/Accordion";
import {
  getAfiliado,
  getMunicipios,
  getProvincias,
  getSectores,
  saveAfiliado,
} from "../../services/profile";
import { useAPIs } from "../../apis/APIsConfig";
import { formatDate } from "../../utils/moment";
import InputMask from "react-input-mask";
import { useGlobalStore } from "../../utils/global";
import Select from "../common/Select";

function EditProfile() {
  useAPIs();
  useDocTitle("Editar Perfil");

  const { showNotification } = useGlobalStore();
  const [numeroPreferido, setNumeroPreferido] = useState(0);

  const [provincias, setProvincias] = useState<any[]>([]);
  const [municipios, setMunicipios] = useState<any[]>([]);
  const [sectores, setSectores] = useState<any[]>([]);
  const [formState, setError, changeHandler, resetAll, resetErrors, setInitialData]  = useForm(
    {}
  );




  useEffect(() => {
    getAfiliado().then((res) => {
      if (res && res.data) {
        const afiliado = { ...res.data.value };
        setInitialData(afiliado);

        getProvincias().then((resProvs) => {
          if (resProvs && resProvs.data) {
            setProvincias(resProvs.data.value);
            if (afiliado.codProvincia) {
              getMunicipios(afiliado.codProvincia).then((resMun) => {
                setMunicipios(resMun.data.value);
                        if (afiliado.codMunicipio) {
                          // pass afiliado.codBarrio so loadSectores can compare against the
                          // value from the payload (formState may not be updated yet)
                          loadSectores(afiliado.codMunicipio, afiliado.codBarrio);
                        }
              });
            }
          }
        });
      }
    });





    
  }, []);

  function disableButton() {
    return (
      false ===
      (formState.data.telefonoMobil &&
        formState.data.telefonoMobil.replaceAll("_", "").length ===
          10) /*celular*/
    );
  }

  function submitForm() {
    changeHandler("telPreferido", formState.data.telefonoMobil ? 3 : 1)();
    const putObj = {
      apartamento: formState.data.numeroApartamento,
      calle: formState.data.calle,
      edificio: formState.data.edificio,
      email: formState.data.email,
      numero: formState.data.numeroCasa,
      piso: formState.data.piso,
      telefonoResidencia: formState.data.telefonoResidencia,
      telefonoOficina: formState.data.telefonoOficina,
      telefonoMobil: formState.data.telefonoMobil,
      codMunicipio: formState.data.codMunicipio,
      codProvincia: formState.data.codProvincia,
      codBarrio: formState.data.codBarrio,
      telPreferido: formState.data.telPreferido,
      emailUsuarioActualiza: "",
    };
    saveAfiliado(putObj).then((res) => {
      if (res && res.data) {
        resetErrors();
        if (res.data.fieldErrors) {
          res.data.fieldErrors.forEach((fieldError) => {
            setError(fieldError.field, fieldError.message);
          });
        } else {
          showNotification({
            title: res.data.message[0].message,
            isError: false,
          });
        }
      }
    });
  }

  function loadMunicipios(idProv) {
    getMunicipios(idProv).then((resMun) => {
      if (
        !resMun.data.value.find((d) => d.id === formState.data.codMunicipio)
      ) {
        changeHandler("codMunicipio", undefined)();
        changeHandler("codBarrio", undefined)();
      }
      setMunicipios(resMun.data.value);
    });
  }

  function loadSectores(idMun, currentCodBarrio = undefined) {
    getSectores(idMun).then((resSec) => {
      const sectoresList = resSec.data.value || [];
      const compareCod =
        currentCodBarrio !== undefined ? currentCodBarrio : formState.data.codBarrio;

      if (!sectoresList.find((d) => d.id === compareCod)) {
        changeHandler("codBarrio", undefined)();
      }
      setSectores(sectoresList);
    });
  }
  function sanitizeEmailInput(value) {
    // Remove spaces, ñ, and Ñ from the input
    return value.replace(/[\sñÑ]/g, ""); 
  }

  // Función para quitar clases de cada elemento
 const configClassFavorito = (event) =>
 {
  
  const element = event.currentTarget;
  const elementos = document.querySelectorAll('.favoriteNumber');

  elementos.forEach((elemento) => {
    elemento.classList.remove('icon-star-full', 'text-semantic-lightyellow');
    elemento.classList.add('icon-star', 'text-gray-80');
  });

  element.classList.remove('icon-star', 'text-gray-80');
  element.classList.add('icon-star-full','text-semantic-lightyellow');
     
  if (element.id === "TelRecidencial") 
  formState.data.telPreferido =1; 
  if (element.id === "TelOficina") 
  formState.data.telPreferido = 2;             
  if (element.id === "TelMovil") 
  formState.data.telPreferido =3;   
          
};





  return (
    <>
      <div className="block xlg:flex space-y-8 xlg:space-y-0 space-x-0 xlg:space-x-10 xl:space-x-12 xxl:space-x-16 pt-10">
        <div className="content-profile">
          <div className="content-description-edit">
            <a href="#!" className="btn-edit">
              <img src="img/img-profile.png" alt="Imagen de perfil" />
              {/*<i className="icon icon-pencil"></i>*/}
            </a>
            <div className="info">
              <h5>{formState.data.nombres}</h5>
              <h5>
                {formState.data.primerApellido} {formState.data.segundoApellido}
              </h5>
              <p>{formState.data.numeroIdentificacion}</p>
            </div>
          </div>
          <ul className="list-profile-data">
            <li>
              <i className="icon icon-identity"></i>
              <div>
                <p>NSS</p>
                <p>
                  <b>{formState.data.idnss}</b>
                </p>
              </div>
            </li>
            <li>
              <i className="icon icon-genre"></i>
              <div>
                <p>Sexo</p>
                <p>
                  <b>{formState.data.sexo === "M" ? "Masculino" : "Femenino"}</b>
                </p>
              </div>
            </li>
            <li>
              <i className="icon icon-user"></i>
              <div>
                <p>Estado Civil</p>
                <p>
                  <b>
                    {formState.data.estadoCivil === "C" ? "Casad" : "Solter"}
                    {formState.data.sexo === "M" ? "o" : "a"}
                  </b>
                </p>
              </div>
            </li>
            <li>
              <i className="icon icon-calendar"></i>
              <div>
                <p>Nacimiento</p>
                <p>
                  <b>
                    {formatDate(formState.data.fechaNacimiento, "DD MMMM YYYY")}
                  </b>
                </p>
              </div>
            </li>
          </ul>
        </div>
        <div className="block xl:min-w-[600px] xxl:min-w-[680px] max-w-full xlg:max-w-[600px] xl:max-w-[600px] xxl:max-w-[680px]">
          <form
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <div className="accordion-container">
              <Accordion title="Información Personal">
                <div className="grid grid-cols-2 gap-y-8 gap-x-6">
                  <div className="form-group">
                    <label>Correo Electrónico</label>
                    <input
                    type="email"
                    className="form-control large"
                    placeholder=""
                    value={formState?.data?.email || ""}
                    onChange={(e) => {
                      if (e?.target?.value !== undefined) {
                        const sanitizedValue = e.target.value.replace(/[\sñÑ]/g, "");
                        changeHandler("email")({
                          target: { value: sanitizedValue },
                        });
                      }
                    }}onKeyDown={(e) => {
                      if (e.key === " " || e.key === "ñ" || e.key === "Ñ") {
                        e.preventDefault();
                      }
                    }}
                  />
                    {formState.errors.email && (
                      <p className="error">{formState.errors.email}</p>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Celular</label>
                    <div className="form-icon">
                      <i onClick={configClassFavorito} id="TelMovil" className={formState.data.telPreferido === 3 ? "icon icon-star-full text-semantic-lightyellow right favoriteNumber":
                       "icon icon-star text-gray-80 right favoriteNumber"}></i>
                      <InputMask
                        type="text"
                        className="form-control large"
                        value={formState.data.telefonoMobil || ""}
                        onChange={changeHandler(
                          "telefonoMobil",
                          undefined,
                          "-"
                        )}
                        mask="999-999-9999"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Teléfono Residencial</label>
                    <div className="form-icon">
                      <i  onClick={configClassFavorito} id="TelRecidencial" className={formState.data.telPreferido === 1 ? "icon icon-star-full text-semantic-lightyellow right favoriteNumber":
                       "icon icon-star text-gray-80 right favoriteNumber"}></i>
                      <InputMask
                        type="text"
                        className="form-control large"
                        value={formState.data.telefonoResidencia || ""}
                        onChange={changeHandler(
                          "telefonoResidencia",
                          undefined,
                          "-"
                        )}
                        mask="999-999-9999"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Teléfono Oficina</label>
                    <div className="form-icon">
                      <i onClick={configClassFavorito} id="TelOficina" className={formState.data.telPreferido === 2 ? "icon icon-star-full text-semantic-lightyellow right favoriteNumber":
                       "icon icon-star text-gray-80 right favoriteNumber"}></i>
                      <InputMask
                        type="text"
                        className="form-control large"
                        value={formState.data.telefonoOficina || ""}
                        onChange={changeHandler(
                          "telefonoOficina",
                          undefined,
                          "-"
                        )}
                        mask="999-999-9999"
                      />
                    </div>
                  </div>
                </div>
              </Accordion>
              <Accordion title="Dirección">
                <div className="grid grid-cols-2 gap-y-8 gap-x-6">
                  <div className="form-group">
                    <Select
                      options={provincias.map((p) => {
                        return { value: p.id, label: p.nombre };
                      })}
                      selectedOption={formState.data.codProvincia}
                      handelChange={(value) => {
                        loadMunicipios(value);
                        changeHandler("codProvincia", value)();
                      }}
                      placeholder="Seleccione provincia"
                      label="Provincia"
                    />
                  </div>
                  <div className="form-group">
                    <Select
                      options={municipios.map((p) => {
                        return { value: p.id, label: p.nombre };
                      })}
                      selectedOption={formState.data.codMunicipio}
                      handelChange={(value) => {
                        loadSectores(value);
                        changeHandler("codMunicipio", value)();
                      }}
                      placeholder="Seleccione municipio"
                      label="Municipio"
                    />
                  </div>
                  <div className="form-group col-span-2">
                    <Select
                      options={sectores.map((p) => {
                        return { value: p.id, label: p.nombre };
                      })}
                      selectedOption={formState.data.codBarrio}
                      handelChange={(value) => {
                        changeHandler("codBarrio", value)();
                      }}
                      placeholder="Seleccione sector"
                      label="Sector"
                    />
                  </div>
                  <div className="form-group">
                    <label>Calle</label>
                    <input
                      type="text"
                      className="form-control large"
                      placeholder=""
                      value={formState.data.calle || ""}
                      onChange={changeHandler("calle")}
                    />
                  </div>
                  <div className="form-group">
                    <label>Número</label>
                    <input
                      type="text"
                      className="form-control large"
                      placeholder=""
                      value={formState.data.numeroCasa || ""}
                      onChange={changeHandler("numeroCasa")}
                    />
                  </div>
                  <div className="form-group col-span-2">
                    <label>Edificio</label>
                    <input
                      type="text"
                      className="form-control large"
                      placeholder=""
                      value={formState.data.edificio || ""}
                      onChange={changeHandler("edificio")}
                    />
                  </div>
                  <div className="form-group">
                    <label>Piso</label>
                    <input
                      type="text"
                      className="form-control large"
                      placeholder=""
                      value={formState.data.piso || ""}
                      onChange={changeHandler("piso")}
                    />
                  </div>
                  <div className="form-group">
                    <label>Apartamento</label>
                    <input
                      type="text"
                      className="form-control large"
                      placeholder=""
                      value={formState.data.numeroApartamento || ""}
                      onChange={changeHandler("numeroApartamento")}
                    />
                  </div>
                </div>
              </Accordion>
            </div>
            <div className="flex justify-end pt-8">
              <button
                type="button"
                disabled={disableButton()}
                onClick={submitForm}
                className="btn btn-primary btn-large w-full lg:w-auto"
              >
                Guardar Cambios
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default EditProfile;
